module.exports = __webpack_public_path__ + "img/qr.607fb813.png";